module.exports = __webpack_public_path__ + "static/img/4.cd0d1126.png";